import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";
import loadData from "../data/loadData";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchNewsPageDataIfNeeded } from "@Pages/News/NewsPost/data/newsPageReducer";

// eslint-disable-next-line import/no-unresolved
const NewsGrid = loadable(() => import("./NewsGrid"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (__CLIENT__) {
      const path = window.location.pathname;
      const searchParams = new URLSearchParams(window.location.search);
      const isCategory = path.includes("/category/");
      const isTag = path.includes("/tag/");
      const isLatest = path.includes("/latest");
      const isSearch = path.includes("/search");
      const searchQuery = searchParams.get("query") || searchParams.get("q") || "";

      dispatch(
        fetchNewsPageDataIfNeeded(props, isCategory, isTag, isSearch, searchQuery, isLatest),
      );
    }
  }, [dispatch, props?.match?.params?.slug, props?.location?.search]);

  return (
    <ErrorBoundary>
      <NewsGrid {...props} />
    </ErrorBoundary>
  );
};

export { NewsGrid as PreFetchNewsGrid };
export { loadData };
